import React, { Component } from 'react';
import axios from 'axios';
import config from '../config'
import { Redirect } from 'react-router'

class ResetPassword extends Component {
    constructor() {
        super();
        this.state = {
            showWarning: false,
            password: '',
            confirmPassword: '',
            redirect_location: '',
            resetSuccess: false
        };

        this.validateToken();

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.backToLogin = this.backToLogin.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.password !== this.state.confirmPassword) {
            let _msg = 'Your password and confirmation password do not match';
            this.setState({
                error: true,
                message: _msg,
                password: '',
                confirmPassword: '',
                resetSuccess: false
            });

        } else {
            let data = {}
            data.password = this.state.password;
            data.password_confirmation = this.state.confirmPassword;
            data.token = this.token;
            // make API call here
            // make the uri dynamic
            // change to axios        
            let _API_URI = config.API_BASE_URL + config.API_CHANGEPASSWORD;
            let _method = 'POST';
            let _headers = {
                "Content-Type": "application/json"
            }
            axios({
                url: _API_URI,
                method: _method,
                data: JSON.stringify(data),
                headers: _headers,
                withCredentials: false,
            })
                .then(response => {
                    console.log(response)
                    this.setState({
                        error: false,
                        password: '',
                        confirmPassword: '',
                        redirect_location: response.data.message,
                        resetSuccess: true
                    });
                    //this.props.history.push(response.message+'/login'); 
                    //window.location = response.data.message+config.LOGINURL_AFTERRESET;
                    //   this.backToLogin();
                })
                .catch(error => {
                    console.log(error)
                    let _msg = 'Oops, looks like you found a bug. Please try again in a new session.';
                    if (error.response) _msg = error.response.data.message;
                    this.setState({
                        error: true,
                        message: _msg,
                        password: '',
                        confirmPassword: '',
                        resetSuccess: false
                    });

                });
        }

    }

    validateToken() {
        let datatoken = window.location.search;
        var tokenValue = datatoken.split("=");
        this.token = tokenValue[1];
        let _API_URI = config.API_BASE_URL + config.VALIDATE_TOKEN + this.token;
        let _method = 'GET';
        let _headers = {
            "Content-Type": "application/json"
        }
        axios({
            url: _API_URI,
            method: _method,
            //data: JSON.stringify(data),
            headers: _headers,
            withCredentials: false,
        })
            .then(response => {
                console.log(response)
                this.setState({
                    showWarning: true,
                    password: '',
                    confirmPassword: '',
                    redirect_location: response.data.message
                });

            }).catch(error => {
                console.log(error,error.response)
                this.setState({
                    showWarning: false,
                    password: '',
                    confirmPassword: '',
                    redirect_location: error.response.data.message
                });

            })

    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    backToLogin() {
        let redirectUrl = "";
        config.REDIRECT_URL.forEach(element => {
            //if (window.location.origin.includes(element.domainId)) {
            if (window.location.origin.indexOf(element.domainId) != -1) {
                // redirectUrl = window.location.origin + "/security/login?redirectURL=" + window.location.origin + element.redirectUrl;
                redirectUrl = window.location.origin + "/security/login" + this.state.redirect_location;
            }
        });
        if (redirectUrl) {
            window.location = redirectUrl;
        }
    }


    render() {
        const { password, confirmPassword, error, message, invalid, success } = this.state;
        return (
            <div className="container">
                <div className="card card-login mx-auto mt-5" >
                    <div className="login-logo" > </div>
                    <div className="login-header text-center">Reset Password</div>
                    <div className="card-body">
                        {error &&
                            <div className="alert alert-danger">
                                <strong>Error! </strong>{message}
                            </div>
                        }
                        <div hidden={this.state.showWarning}>
                            <div className="text-center mb-4">
                                <p>Link is Expired, Kindly contact to your Administrator</p>
                            </div>
                            {/* <div className="text-center">
                            <a className="d-block small mt-3" href="/security/login">Login</a>                            
                        </div> */}
                        </div>
                        <div hidden={!this.state.resetSuccess}>
                            <div className="text-center mb-4">
                                <p>Your password has been changed successfully. Please try log in now</p>
                            </div>
                        </div>
                        <div hidden={!this.state.showWarning || this.state.resetSuccess}>
                            <form onSubmit={this.handleSubmit}>
                                <div className="form-group">
                                    {/*<div className="form-label-group">*/}
                                    <input type="password"
                                        name="password"
                                        className="form-control custom-input password-input"
                                        placeholder="Password *"
                                        required="required"
                                        value={password}
                                        onChange={this.handleInputChange}
                                        minLength="8"
                                        maxLength="30"
                                        pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,30}$"
                                    />

                                </div>
                                <div className="form-group">
                                    {/*<div className="form-label-group">*/}

                                    <input type="password"
                                        name="confirmPassword"
                                        className="form-control custom-input password-input"
                                        placeholder="Confirm Password *"
                                        required="required"
                                        value={confirmPassword}
                                        onChange={this.handleInputChange}
                                        minLength="8"
                                        maxLength="30"
                                        pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,30}$"
                                    />
                                </div>
                                {/* <div className="resetpassword-note">Note: <br/> Password must meet at least 1 uppercase character(A-Z), at least 1 lowercase character(a-z),at least 1 digit(0-9),at least 1 special character and at least 8 characters and at most 30 characters.</div> */}
                                <div>Note:</div>
                                <ul className="bullets">
                                    <li className="resetpassword-note">Password must meet at least 1 uppercase character(A-Z)</li>
                                    <li className="resetpassword-note">At least 1 lowercase character(a-z)</li>
                                    <li className="resetpassword-note">At least 8 characters and at most 30 characters.</li>
                                    <li className="resetpassword-note">At least 1 digit(0-9)</li>
                                    <li className="resetpassword-note">At least 1 special character</li>
                                </ul>
                                <button className="btn btn-primary btn-block" type="submit">Submit</button>
                            </form>
                        </div>
                        <div className="text-center">
                            <a className="small pointer bluefont"  onClick={this.backToLogin}> Login </a>
                        </div>
                    </div>
                    <div className="login-footer"> © 2024 Reliance Industries Limited. All rights reserved.</div>
                </div>
            </div>
        );
    }
}

export default ResetPassword;


// WEBPACK FOOTER //
// ./src/components/ResetPassword.js